module.exports = __webpack_public_path__ + "img/15.e9d6fd93.jpg";